import {Model} from 'react3l-common';
import {Field} from 'react3l-decorators';

export class AppUserSwitchAccount extends Model {
  @Field(String)
  public accessToken?: string;

  @Field(String)
  public refreshToken?: string;
}